/* eslint-disable sort-keys */
export const DEFAULT_TITLE =
  'Essential Aesthetics | Plastische chirurgie naar een hoger niveau!'

export const sectionsPresets = {
  Herosection: 'herosectionpresets',
  Awarenesssection: 'ratingssectionpresets',
  Treatmentssection: 'treatmentssectionpresets',
  Teamsection: 'teamsectionpresets',
  Reviewssection: 'reviewsectionpresets',
  Trustmarksection: 'trustmarkpresets',
  Uspssection: 'experiencesectionpresets',
  Ctasection: 'ctasectionpresets',
  Treatmentslist: 'treatmentlistpresets',
  Treatmentresult: 'treatmentresultpresets',
}

export const promotedTreatments = {
  en: [
    '/plastic-surgery/liposuction/',
    '/buttocks/buttock-augmentation-with-implants/',
    '/buttocks/buttock-augmentation-with-fillers/',
    '/skin/morpheus8/',
    '/plastic-surgery/liposuction/bodytite/',
    '/skin/facetite/',
    '/plastic-surgery/facelift/',
    '/breasts/breast-augmentation/',
    '/breasts/breast-lift/',
    '/breasts/breast-reduction/',
    '/muscle-relaxants/facelift/liquid/',
    '/fillers/',
    '/muscle-relaxants/crows-feet/',
    '/muscle-relaxants/eyebrow-lift/',
    '/fillers/jawline-tightening/',
  ],
  nl: [
    '/plastische-chirurgie/liposuctie/bodytite/',
    '/huid/facetite/',
    '/huid/morpheus/',
    '/billen/bilvergroting-met-fillers/',
    '/spierontspanners/facelift/liquid/',
    '/borsten/borstlift/',
    '/fillers/kaaklijn-verstrakken/',
    '/spierontspanners/kraaienpootjes/',
    '/plastische-chirurgie/facelift/',
    '/plastische-chirurgie/liposuctie/',
    '/billen/bilvergroting-met-implantaten/',
    '/borsten/borstvergroting/',
    '/borsten/borstverkleining/',
    '/fillers/',
    '/spierontspanners/fronsrimpel/',
    '/spierontspanners/wenkbrauwlift/',
  ],
}

export const promotedTitles = {
  en: ['Our signature treatments using cutting-edge technology'],
  nl: ['Onze top behandelingen met geavanceerde technologie'],
}
